import { oldNews } from "@/mocks/homeData";

export default function OldNews() {
  return (
    <section id="oldnews" className="shell-wrap py-14 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="section-eyebrow">
            <i className="ri-video-line" /> 冷门旧闻 · 考古专区
          </p>
          <h2 className="title-serif mt-2 text-2xl font-black md:text-4xl">
            被时间折叠的旧素材
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-ink/60 md:text-base">
            不只有热门瓜料，老片、旧访、早年发言也在持续归档，冷门内容同样一页查全。
          </p>
        </div>
      </div>

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        {oldNews.map((n) => (
          <article
            key={n.title}
            className="group card-lift flex items-center gap-4 rounded-2xl border border-ink/10 bg-paper p-4 md:p-5"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cream text-xl text-ember">
              <i className="ri-file-history-line" />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 text-xs text-ink/45">
                <span className="rounded-md bg-ink/5 px-2 py-0.5 font-semibold text-ink/70">{n.cat}</span>
                {n.tag && <span className="text-ember">· {n.tag}</span>}
              </div>
              <h3 className="mt-1.5 truncate text-sm font-semibold leading-snug group-hover:text-ember md:text-base">
                {n.title}
              </h3>
            </div>
            <i className="ri-arrow-right-line text-ink/30 transition-all group-hover:translate-x-1 group-hover:text-ember" />
          </article>
        ))}
      </div>

      <div className="mt-6 rounded-2xl border border-dashed border-ink/20 bg-paper/60 p-5 text-center">
        <p className="text-sm text-ink/60">
          考古库持续扩充，还有 <b className="font-bold text-ink">更多年代跨度更远的旧物料</b> 正在逐条整理入档。
        </p>
      </div>
    </section>
  );
}